import { InputHTMLAttributes } from 'react'
import cn from 'classnames'

import './styles.scss'

export const Switch = ({ style, className, ...rest }: InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <label className={cn('switch', className)} style={style}>
      <input type="checkbox" className="switch-input" {...rest} />
      <div aria-hidden="true" className="switch-container"></div>
    </label>
  )
}
